import { useCallback } from "react";
import update from "immutability-helper";
import { AttributeCardContainerProps } from "types";
import DragableAttributeCard from "ui/molecules/DragableCard";

function AttributeCardContainer({
  attributes,
  onOpenModal,
  setAttributes,
}: AttributeCardContainerProps) {
  const moveCard = useCallback(
    (dragIndex: number, hoverIndex: number) => {
      const dragCard = attributes[dragIndex];
      setAttributes(
        update(attributes, {
          $splice: [
            [dragIndex, 1],
            [hoverIndex, 0, dragCard],
          ],
        })
      );
    },
    [attributes, setAttributes]
  );
  return (
    <>
      {attributes.map((attribute, index) => (
        <DragableAttributeCard
          key={index}
          moveCard={moveCard}
          index={index}
          name={attribute.name}
          image={URL.createObjectURL(attribute.files[0])}
          totalTraits={attribute.files.length}
          onClick={() => onOpenModal(index)}
        />
      ))}
    </>
  );
}

export default AttributeCardContainer;
